import { useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import { useAuth } from "../../context/AuthContext";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ApolloError, useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { DELETE_ATTACHMENT, TICKET_ACTIONS, UPDATE_DEFECT } from "../../api/mutation";
import { showError, showSuccess } from "../../components/common/ToastNotification";
import BreadCumb from "../../components/common/Breadcrumb";
import InputsNew from "../../components/common/InputsNew";
import backArrow from "../../assets/task/back_arrow.svg";
import Loader from "../../components/common/Loader";
import plusIconuplad from "../../assets/task/plus_icon_uload.svg";
import imgUploadicon from "../../assets/task/imguploadicon.svg";
import SearchableInputsDropdown from "../../components/common/SearchableDropdown";
import { DEFECTS, MASTER_STATUS_VALUES } from "../../api/query";
import { uploadFileDirectly } from "../../pages/projects/AddProject";
import documentBusinessdocu from "../../assets/task/document_business_docu.svg";

const severityOptions = [
    {
        key: 101,
        name: "Low"
    },
    {
        key: 102,
        name: "Medium"
    },
    {
        key: 103,
        name: "High"
    },
    {
        key: 104,
        name: "Critical"
    }
]

interface AddDefectConfig {
    title: string;
    severity: String;
    description?: string
    status: String;
    // stepsToReproduce: string;
    // expectedBehaviour: string;
    // actualBehaviour: string;
    // imageurl?: string;
    // fileName?: string;
}

const addDefectSchema = yup.object().shape({
    title: yup.string()
        .test('not-only-whitespace', 'Please add a valid Title', value => !value || value.trim().length > 0)
        .required('This field is required'),
    severity: yup.string().required('This field is required'),
    description: yup.string()
        .test('not-only-whitespace', 'Please add a valid Title', value => !value || value.trim().length > 0).nullable(),
    status: yup.string().required('This field is required'),
    // stepsToReproduce: yup.string()
    //     .test('not-only-whitespace', 'Please add valid Steps', value => !value || value.trim().length > 0)
    //     .required('This field is required'),
    // expectedBehaviour: yup.string()
    //     .test('not-only-whitespace', 'Please add valid Expected Behaviour', value => !value || value.trim().length > 0)
    //     .required('This field is required'),
    // actualBehaviour: yup.string()
    //     .test('not-only-whitespace', 'Please add valid Actual Behaviour', value => !value || value.trim().length > 0)
    //     .required('This field is required'),
    // imageurl: yup.string(),
    // fileName: yup.string(),
});

const ViewTicket = () => {
    const fileInputRef = useRef<HTMLInputElement>(null);
    const navigate = useNavigate()
    const { userInfo } = useAuth()
    const employeeID = userInfo?.employee_id || '';

    const location = useLocation()

    const state = location.state as {
        ticket: any
    };

    const { ticket } = state

    // const [imgUrl, setImgUrl] = useState("");
    const [isUploading, setIsUploading] = useState<boolean>(false);
    const [validationMessage, setValidationMessage] = useState<string | null>(null);

    const [imgUrls, setImgUrls] = useState<string[]>([]);
    const [fileNames, setFileNames] = useState<string[]>([]);
    const [existingAttachments, setExistingAttachments] = useState<
        { id: string; file_url: string; file_name: string }[]
    >([]);
    const [statusOptions, setStatusOptions] = useState<{ key: string; name: string }[]>([]);


    // const [showModal, setShowModal] = useState(false);
    const [modalImage, setModalImage] = useState<string | null>(null);


    // react hook form
    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
        trigger,
        watch
    } = useForm<any>({
        resolver: yupResolver(addDefectSchema)
    });


    //api
    //api
    const [ticketAction, { loading: ticketActionLoading }] = useMutation(TICKET_ACTIONS, {

        fetchPolicy: 'no-cache',
    })

    const { data, loading } = useQuery(MASTER_STATUS_VALUES, {

        fetchPolicy: 'no-cache',
    });

    // const [getDefectByID, { data, loading }] = useLazyQuery(DEFECTS, {
    //     fetchPolicy: 'no-cache'
    // })

    // const [deleteAttachment, { loading: deleteAttachmentLoading }] = useMutation(DELETE_ATTACHMENT, {
    //     fetchPolicy: 'no-cache',
    // })

    //useEffects
    useEffect(() => {
        if (data?.master_status_values?.status_code === 200) {
            const options = data.master_status_values?.status_values?.map((item: any) => ({
                key: item.id,
                name: item.name
            }));
            setStatusOptions(options);
        }

    }, [data])

    useEffect(() => {
        if (ticket) {
            // const defect = data.defects.defects[0]

            setValue("title", ticket?.title)
            setValue("severity", ticket?.severity)
            // setValue("stepsToReproduce", ticket?.steps_to_reproduce)
            // setValue("expectedBehaviour", ticket?.expected_behavior)
            // setValue("actualBehaviour", ticket?.actual_behavior)
            setValue("description", ticket?.description)
            setValue("status", ticket?.status)

            // if (ticket?.attachments_urls?.length > 0) {
            //     const attachments = ticket.attachments_urls;
            //     const fileUrls = attachments.map((attachment: any) => attachment.file_url);
            //     const fileNames = attachments.map((attachment: any) => attachment.file_name);

            //     // Set the state with the extracted data
            //     setImgUrls(fileUrls);
            //     setFileNames(fileNames);

            //     setExistingAttachments(attachments.map((a: any) => ({
            //         id: a.id,
            //         file_url: a.file_url,
            //         file_name: a.file_name
            //     })));
            // }
        }
    }, [ticket])

    //watch
    const watchSeverity = watch('severity')
    const watchStatus = watch('status');

    function handleSelectStatus(key: number, name: string): void {
        // setValue('statusID', key)
        setValue('status', name)
        trigger('status')
    }


    function handleSelectSeverity(key: number, name: string): void {
        setValue('severity', name)
        trigger('severity')
    }

    async function onSubmit(data: AddDefectConfig) {
        try {
            const response = await ticketAction({
                variables: {
                    id: ticket?.id,
                    priority: data?.severity,
                    status: data?.status
                }
            });

            if (response.data.ticket_actions?.status_code === 200) {
                // onClose()
                showSuccess(response.data.ticket_actions?.message)
                navigate(-1)
            }
        } catch (error) {
            if (error instanceof ApolloError) {
                showError(error.message)
            }
        }
    }

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)} id="cts-respon-p-dv" className="w-full flex flex-col items-start justify-start py-40 px-20  mq1490:px-[30px]  mq575:px-5 box-border gap-[24px] max-w-[100%] mq1425:max-w-full">
                <div className=" flex flex-col items-start justify-start gap-6 w-full">
                    <BreadCumb />
                    {/* <div className="self-stretch rounded flex flex-col items-start justify-start text-dimgray">
                                <div className="flex flex-row items-center justify-start">
                                    <div className="overflow-hidden flex flex-row items-center justify-start gap-2">
                                        <div className="relative [text-decoration:underline]">Dashboard</div>
                                        <img className="w-4 relative h-4 overflow-hidden shrink-0" alt="" src="Right 16px.svg" />
                                        <div className="relative font-semibold text-gray">Add New Task</div>
                                    </div>
                                </div>
                            </div> */}
                    <div className="self-stretch flex flex-row items-center justify-start gap-[5px] text-2xl">
                        <img className="w-6 relative h-6 overflow-hidden shrink-0 cursor-pointer dark-white-img" alt="" src={backArrow}
                            onClick={() => navigate(-1)}
                        />
                        <h3 className="m-0 flex-1 relative text-inherit font-bold font-inherit inline-block max-w-[calc(100%_-_29px)] mq450:text-base dark:text-white">View Ticket</h3>
                    </div>
                    <div className="m-0 self-stretch rounded-radius-radius-lg bg-surface-bg-blue darkborder-b-remove flex flex-col items-start justify-start p-8 mq575:p-3 box-border gap-spacing-lg max-w-full mq825:pt-5 mq825:pb-5 mq825:box-border mq1425:pt-[21px] mq1425:pb-[21px] mq1425:box-border">
                        {/* <h5 className="my-0 text-xl-dv self-stretch relative text-lg">Goal Details</h5> */}
                        <div className="grid grid-cols-4 mq1400:grid-4 mq1275:grid-cols-3 mq950:grid-cols-2 mq575:grid-cols-1 mt-[8px] gap-[8px] min-w-full">
                            <InputsNew
                                contentPlaceholder="Title"
                                label="Title*"
                                type="text"
                                register={register('title')}
                                errorMessage={errors.title}
                                disabled={true}
                            />
                            <SearchableInputsDropdown
                                label="Severity*"
                                initialValue={watchSeverity}
                                placeHolder="--Select--"
                                options={severityOptions}
                                onSelect={handleSelectSeverity}
                                errorMessage={errors?.severity}
                            />
                            <SearchableInputsDropdown
                                label="Status*"
                                initialValue={watchStatus}
                                placeHolder="Select Status"
                                options={statusOptions}
                                onSelect={handleSelectStatus}
                                errorMessage={errors?.status}
                            />
                        </div>
                        <div className="self-stretch flex flex-col items-start justify-start text-sm">
                            <div className="self-stretch rounded-radius-md  overflow-hidden flex flex-row items-start justify-start pt-2 shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] ">
                                <InputsNew
                                    contentPlaceholder="Description"
                                    label="Description"
                                    type="textarea"
                                    register={register('description')}
                                    errorMessage={errors.description}
                                    disabled={true}
                                />
                            </div>
                        </div>
                        {ticket?.attachments_urls?.length > 0 && (
                            <div className="customerattachment_list-items">
                                <p className="text-sm dark:text-white my-0 email-label-dv mb-2"><b>Customer Attachments</b></p>
                                <div className="customerattachment_list py-1 pr-4 grid gap-[8px] max-h-[130px] overflow-y-auto">
                                    {ticket?.attachments_urls?.map((a: any) => {
                                        return (
                                            <a
                                                key={a}
                                                href={a}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="cursor-pointer items_customerattachment_list flex justify-between border-[1px] border-solid border-surface-border py-2.5 px-[15px] dark:bg-slate-700"
                                            >
                                                {/* <div className="cursor-pointer items_customerattachment_list flex justify-between border-[1px] border-solid  border-surface-border  py-2.5 px-[15px] dark:bg-slate-700 "> */}
                                                <div className="flex gap-[8px] items-center">
                                                    <img src={documentBusinessdocu} className="w-5 h-5" alt="" />
                                                    <p className="my-0 dark:text-white text-black text-sm">{a}</p>
                                                </div>
                                                {/* <div className="flex gap-[8px] items-center">
                                                                <p className="my-0 dark:text-white text-black text-sm">240 KB</p>
                                                                <img src={downloaDoutlineicon} className="w-3 h-3" alt="" />
                                                            </div> */}
                                                {/* </div> */}
                                            </a>
                                        )
                                    })}
                                </div>
                            </div>
                        )}
                        {/* <div className="self-stretch flex flex-col items-start justify-start text-sm">
                            <div className="self-stretch rounded-radius-md  overflow-hidden flex flex-row items-start justify-start pt-2 shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] ">
                                <InputsNew
                                    contentPlaceholder="Steps to Reproduce"
                                    label="Steps to Reproduce*"
                                    type="textarea"
                                    register={register('stepsToReproduce')}
                                    errorMessage={errors.stepsToReproduce}
                                />
                            </div>
                        </div>
                        <div className="self-stretch flex flex-col items-start justify-start text-sm">
                            <div className="self-stretch rounded-radius-md  overflow-hidden flex flex-row items-start justify-start pt-2 shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] ">
                                <InputsNew
                                    contentPlaceholder="Actual Behaviour"
                                    label="Actual Behaviour*"
                                    type="textarea"
                                    register={register('actualBehaviour')}
                                    errorMessage={errors.actualBehaviour}
                                />
                            </div>
                        </div>
                        <div className="self-stretch flex flex-col items-start justify-start text-sm">
                            <div className="self-stretch rounded-radius-md  overflow-hidden flex flex-row items-start justify-start pt-2 shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] ">
                                <InputsNew
                                    contentPlaceholder="Expected Behaviour"
                                    label="Expected Behaviour*"
                                    type="textarea"
                                    register={register('expectedBehaviour')}
                                    errorMessage={errors.expectedBehaviour}
                                />
                            </div>
                        </div> */}
                        {/* <div className="grid grid-cols-4 mq1400:grid-4 mq1275:grid-cols-4 mq950:mq1275:grid-cols-2 mq575:mq1275:grid-cols-1 gap-[16px] min-w-full">
                            <div className=" rounded flex flex-col items-center justify-start text-left mq1275:min-w-[20%] mq1275:justify-start min-w-[22%]">
                                <label className="self-stretch relative font-semibold dark:text-white pb-2">Add Attachment</label>
                                <div
                                    className={`${imgUrl ? "upload_img_box" : ""} rounded  mq1275:bg-white flex flex-col items-center justify-end p-2.5 box-border max-w-[100%] min-w-[100%] mq950:min-w-full text-center agencyinfo-img-blg mq950:p-0`} id="calltype-row "

                                >
                                    {isUploading ? (
                                        <div className="self-stretch rounded bg-white flex flex-col items-center justify-center py-[33px] px-[9px] border-[1px] border-dashed border-neutral-200">
                                            <div className="self-stretch flex flex-col items-center justify-center gap-[10px]">
                                                <div className="text-main-blue">Uploading...</div>
                                            </div>
                                        </div>
                                    ) : imgUrl ? (
                                        <div className="bg-white p-2 shadow-\[0px_1px_2px_rgba\(16\2c _24\2c _40\2c _0\.05\)\] border-surface-border inner_upload_img_box onborading-bdr-blg">
                                            <img
                                                className="min-w-36 h-[100px] relative overflow-hidden shrink-0 cursor-pointer imgagency-upload"
                                                loading="lazy"
                                                alt=""
                                                src={imgUrl}
                                                onClick={() => setShowModal(true)}
                                            />

                                            {showModal && (
                                                <div
                                                    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
                                                    onClick={() => setShowModal(false)}
                                                >
                                                    <img
                                                        src={imgUrl}
                                                        alt="Preview"
                                                        className="max-w-full max-h-full object-contain"
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <div className="self-stretch rounded bg-white flex flex-col items-center justify-center py-[35px] px-[9px] border-[1px] border-dashed border-neutral-200">
                                            <div className="self-stretch flex flex-col items-center justify-center gap-[10px]">
                                                <img
                                                    className="w-6 h-6 relative overflow-hidden shrink-0 dark-white-img"
                                                    loading="lazy"
                                                    alt=""
                                                    src={imgUploadicon}
                                                />
                                                <p className="self-stretch relative capitalize my-0">
                                                    Upload
                                                </p>
                                                <div
                                                    className="cursor-pointer rounded plus-task-btn flex flex-row items-center justify-center p-1.5"
                                                    onClick={handleIconClick}
                                                >
                                                    <img
                                                        className="h-5 w-5 relative"
                                                        loading="lazy"
                                                        alt=""
                                                        src={plusIconuplad}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    style={{ display: "none" }}
                                    onChange={handleFileUpload}
                                    accept=".jpg,.jpeg,.png"
                                // accept="image/*"
                                />
                                {validationMessage && (
                                    <p className="text-red p-2 cts-bg-error my-0 flex items-center gap-[4px] ctcerror-width-blg">
                                        <img src={''} alt="" />
                                        {validationMessage}
                                    </p>
                                )}
                            </div>
                        </div> */}
                        <div className="self-stretch flex flex-row items-center justify-end py-0 pr-0 gap-[8px] mq950:box-border mq1425:flex-wrap  mq1425:box-border mq450:box-border">
                            <button className="cursor-pointer bg-white py-2.5 h-[44px] mq575:h-[35px] px-[42px] btn-text-purple mq575:py-[12.5px] mq575:px-[25px] rounded-radiuscomponent-button box-border flex flex-row items-center justify-center gap-[12px] border-[2px] border-solid border-surface-primary-surface hover:bg-gainsboro-100 hover:box-border hover:border-[2px] hover:border-solid hover:border-dodgerblue"
                                // onClick={handleGoBack}
                                type="button"
                                onClick={() => navigate(-1)}
                            >
                                <div className="relative text-sm font-body-xs-semi-bold  dark:text-white text-center inline-block">
                                    Cancel
                                </div>
                            </button>
                            <button className={`cursor-pointer [border:none] py-2.5 h-[44px] mq575:h-[35px] px-[42px] mq575:py-[12.5px] mq575:px-[25px] bg-surface-primary-surface flex flex-row items-center justify-center gap-[12px] hover:bg-dodgerblue`}
                                // disabled={(err || careDelErr) !== ''}
                                type="submit"
                            >
                                <div className="relative text-sm font-body-xs-semi-bold text-surface-bg-primary text-center inline-block">
                                    Save
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </form >
            {(ticketActionLoading || loading) && (
                <Loader />
            )}
        </>
    )
}

export default ViewTicket